<ng-container *ngIf="costCenterState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{"app.dialog.add-hourly-wage.title.header" | translate: { costCenter: costCenter.name } }}
    </h1>
    <div mat-dialog-content>
        <mat-generic-input [fields]="state.hourlyWageAddFields" [(inputFormGroup)]="formGroup"></mat-generic-input>
    </div>

    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="closeDialog(false)">{{ "app.button.cancel.label" | translate }}</button>
        <button [disabled]="!(dialogFieldsValid$ | async)" mat-flat-button color="primary" (click)="onSave()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
